import _ from 'lodash';
import moment from 'moment';

/**
 * Global notifications reducer
 */

export default function notificationsReducer(state, action) {
    if (!state) {
        state = {
            loaded: false, // initial load
            all: [],
        };
    }

    switch (action.type) {
        case 'SESSION_UPDATES':
            state = notificationsReducer(state, app.actions.notifications.received(action.updates.notifications));
            break;
        case 'NOTIFICATIONS_RECEIVED':
            {
                state = {
                    ...state,
                    loaded: true,
                    all: _([...action.notifications, ...state.all])
                        .map(notif => ({
                            ...notif,
                            sent_on: moment.utc(notif.sent_on).toISOString(),
                            read: notif.read ? moment.utc(notif.read).toISOString() : null,
                        }))
                        .uniqBy('id')
                        .value(),
                };
            }
            break;
        case 'NOTIFICATION_READ':
            state = {
                ...state,
                all: state.all.map(notification =>
                    notification.id == action.id
                        ? {
                              ...notification,
                              read: true,
                              read: new Date().toISOString(),
                          }
                        : notification
                ),
            };
            break;
    }

    return state;
}
